export enum PostTypeEnum {
  SIMPLE_POST = 'SIMPLE_POST',
  PROJECT_POST = 'PROJECT_POST',
  PROJECT_MEDIA_POST = 'PROJECT_MEDIA_POST',
  COLLABORATION_MEDIA_POST = 'COLLABORATION_MEDIA_POST',
  EVENT_MEDIA_POST = 'EVENT_MEDIA_POST',
  EVENT_DISCUSSION_POST = 'EVENT_DISCUSSION_POST',
  HISTORY_POST = 'HISTORY_POST',
  DESCRIPTION_POST = 'DESCRIPTION_POST'
}
